import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify);

export default new Vuetify({
	icons: {
		iconfont: 'md',
	},
	theme: {
		themes: {
			light: {
				primary: "#424242",
				secondary: "#d32f2f",
				accent: "#d32f2f"
			},
		},
	},
});
